var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('img',{attrs:{"width":"100%","src":require("@/assets/images/welcome.jpeg")}})])}]

export { render, staticRenderFns }